<div class="body-container mx-auto">
  <header>
    <h1 class="page-title text-center">
      Forgot Password
    </h1>
  </header>
  <div class="reg-form-content">
    <p class="page-subtitle text-center mt-3 mb-4">
      We sent a verification code to <span style="color: #CD0000">{{ email }}</span>. It can take up to 10 minutes to receive. Please also check your spam folder.
    </p>
  </div>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <div class="input-container">
      <span class="input-label">Verification Code</span>
      <input
        type="text"
        class="input"
        formControlName="verificationCode"
        mask="0 0 0 - 0 0 0"
        placeholder="_ _ _ - _ _ _"
      >
      <span
        class="error"
        *ngIf="f.verificationCode.touched && f.verificationCode.value === ''"
      >Please enter verification code.</span>
      <span
        class="error"
        *ngIf="f['verificationCode'].dirty && f['verificationCode'].status=='INVALID'  &&  f['verificationCode'].value !== ''"
      >Please enter full 6-digit verification code</span>
    </div>

    <app-password-form
      #passwordForm
      formControlName="passwordForm"
    ></app-password-form>
    <div class="action-container">
      <button
        type="submit"
        class="btn btn-danger btn-block"
        [disabled]="!form.valid"
      >Submit</button>
    </div>
  </form>
</div>
